import { CheckoutDeliveryProvider as i, CheckoutDeliveryStatus as e } from "@ancon/wildcat-types";
function v(r) {
  return (r == null ? void 0 : r.deliveryProvider) === i.Wolt && (r == null ? void 0 : r.deliveryStatus) === e.PickedUp;
}
export {
  v as default
};
